import { Link } from 'react-router-dom';
import { ReactComponent as ExternalLinkIcon } from 'src/assets/external_link.svg';
import classNames from 'classnames';
import css from './smart-link.module.scss';

interface SmartLinkProps extends React.PropsWithChildren {
  href: string;
  className?: string;
}

export function isValidUrl(string: string) {
  try {
    new URL(string);
    return true;
  } catch (e) {
    return false;
  }
}

export default function SmartLink({ href, className, children }: Readonly<SmartLinkProps>) {
  const isExternal = isValidUrl(href);

  if (isExternal) {
    return (
      <a href={href} target='_blank' rel='noopener noreferrer' className={classNames(css.smartLink, className ?? '')}>
        {children}
        <ExternalLinkIcon />
      </a>
    );
  }

  return (
    <Link to={href} className={classNames(css.smartLink, className ?? '')}>
      {children}
    </Link>
  );
}
